import Dashboard from './dashboard/dashboard'
import User from './users'
import { userReducer } from './users/duck'
import ChangeProfile from '../default/profiles/index'
import Profile from './profiles'
import Pricing from './pricing'
import { APP_NAME, APP_TITLE } from './config'

// Product identity (host still uses REACT_APP_NAME for shell branding)
export const appName = APP_NAME
export const appTitle = APP_TITLE

// Reducers do projeto (unused modules kept on disk, not registered)
export const reducers = {
  user: userReducer,
}

// Rotas do projeto — slim: home, users, profiles, pricing
export const routes = [
  { exact: true, path: '/', component: Dashboard },
  { exact: true, path: '/users', component: User },
  { exact: true, path: '/profiles', component: Profile },
  { exact: true, path: '/pricing', component: Pricing },
  { exact: true, path: '/trocar-perfil', component: ChangeProfile },
]

// Menu do projeto — Users + Profiles + Pricing (+ dashboard home)
export const menu = {
  '/': { title: 'Início', icon: 'home' },
  '/pricing': {
    title: 'Preços',
    icon: 'money',
  },
  '/profiles': {
    title: 'Perfis',
    icon: 'lock',
  },
  '/users': {
    title: 'Usuários',
    icon: 'user',
  },
}
